import { Component, OnInit, inject, signal } from '@angular/core';
import { FileList } from '../../shared/components/file-list/file-list';
import { Data } from '../../core/services/data';
import { FileItem } from '../../core/models/file';

interface ArchiveCategory {
  id: string;
  label: string;
  jsonFile: string;
  downloadPath: string;
}

@Component({
  selector: 'app-ergebnisse',
  standalone: true,
  imports: [FileList],
  templateUrl: './ergebnisse.html'
})
export class Ergebnisse implements OnInit {
  private dataService = inject(Data);

  files: FileItem[] = [];
  isLoading = true;
  error: string | null = null;

  selectedCategory = signal<string>('aktuell');

  categories: ArchiveCategory[] = [
    {
      id: 'aktuell',
      label: 'Aktuell',
      jsonFile: 'ergebnisse.json',
      downloadPath: 'ergebnisse/'
    },
    {
      id: 'bodensee',
      label: 'Ehemaliger Kreis Bodensee',
      jsonFile: 'archiv-bodensee.json',
      downloadPath: 'archiv/bodensee/'
    },
    {
      id: 'ravensburg',
      label: 'Ehemaliger Kreis Ravensburg',
      jsonFile: 'archiv-ravensburg.json',
      downloadPath: 'archiv/ravensburg/'
    }
  ];

  ngOnInit() {
    this.loadFiles();
  }

  selectCategory(categoryId: string) {
    this.selectedCategory.set(categoryId);
    this.loadFiles();
  }

  getCurrentCategory(): ArchiveCategory {
    return this.categories.find(c => c.id === this.selectedCategory()) || this.categories[0];
  }

  loadFiles() {
    this.isLoading = true;
    this.error = null;

    const category = this.getCurrentCategory();

    this.dataService.getFilesByCategory(category.jsonFile).subscribe({
      next: (data) => {
        this.files = data;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading files:', err);
        this.error = 'Fehler beim Laden der Dateien';
        this.isLoading = false;
      }
    });
  }
}
